var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", {
      staticClass: "rounded-box mb-2 p-3",
      domProps: { innerHTML: _vm._s(_vm.$t("try-refresh")) }
    }),
    _vm._v(" "),
    _c("hr", { staticClass: "mb-4 mt-4 w-100" }),
    _vm._v(" "),
    _c("div", [
      _c(
        "a",
        {
          attrs: {
            href:
              "https://www.opensalud.es/es/Home/FaqAppRequisitosIncidencias",
            target: "_blank"
          }
        },
        [
          _c("b-icon-info-circle", { staticClass: "mr-2" }),
          _vm._v(_vm._s(_vm.$t("faq")))
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("hr", { staticClass: "mb-4 mt-4 w-100" }),
    _vm._v(" "),
    _c("div", { attrs: { id: "support-chat" } }, [
      _c(
        "div",
        {
          staticClass: "mb-3 clickable",
          on: {
            click: function($event) {
              return _vm.$helpers.openSupportChat()
            }
          }
        },
        [
          _c("b-icon-chat", { staticClass: "mr-2" }),
          _c("span", {
            domProps: { innerHTML: _vm._s(_vm.$t("chat-attention")) }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-449b80f7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-449b80f7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/video-launcher/HelpSection.vue
// module id = 2929
// module chunks = 28 34